import moment from 'moment';

export const simpleFormat = (obj) => (obj && obj.dateAdded ? moment(obj.dateAdded).format('DD/MM/YYYY') : '');
